import React, { useRef, useState } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../../config/url";
import {
  useNotification,
  getErrorMessageByKey,
  jsonFormatText,
  isValidateNullText,
  Modal,
  Input,
  Select,
} from "@vokymlak/kabinet-ui";

function ModalAddHandbookEntry(props) {
  const [isPublic, setIsPublic] = useState(false);

  const inputTitle = useRef(null);
  const inputHandbookEntryTypeTag = useRef(null);

  const { notification } = useNotification();

  const changeAdd = (event) => {
    event.preventDefault();

    const title = jsonFormatText(inputTitle.current.value);
    const handbookEntryTypeTag = inputHandbookEntryTypeTag.current.value;

    if (isValidateNullText(title)) {
      notification("Заполните все обязательные поля", "red");
      return;
    }

    const jsonData = JSON.stringify({
      title: title,
      handbook_entry_type: {
        tag: handbookEntryTypeTag,
      },
      is_public: isPublic,
    });

    axios
      .post("/api/handbook-entry/add", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Запись добавлена", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    <Modal handleClose={() => props.handleClose()}>
      <form className="Form" onSubmit={(event) => changeAdd(event)}>
        <div className="Form__title">Статья</div>

        <div className="Form__field">
          <Select
            isFixed={true}
            reference={inputHandbookEntryTypeTag}
            options={[
              {
                title: "Статья",
                value: "ARTICLE",
              },
              {
                title: "Группа статей",
                value: "GROUP_ARTICLES",
              },
              {
                title: "Заголовок",
                value: "HEADING",
              },
            ]}
            label="Тип записи"
          />
        </div>

        <div className="Form__field">
          <Input reference={inputTitle} type="text" label="Наименование *" />
        </div>

        <div className="Form__field Form__field_last">
          <div
            className="Button__swith"
            style={{
              padding: "8px",
              width: "100%",
              border: isPublic ? "2px solid #ffe082" : "2px dashed #20202015",
              backgroundColor: isPublic ? "#ffe082" : "#ffffff",
              borderRadius: 6,
              marginTop: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
            onClick={() => setIsPublic(!isPublic)}
          >
            <div
              className="Swith__text"
              style={{
                fontSize: 17,
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
              }}
            >
              Опубликовать
            </div>
            <div
              className={
                "Swith Swith_gray" +
                ((isPublic && " Swith_active Swith_active_gray") || "")
              }
            ></div>
          </div>
        </div>

        <div className="Form__actions Form__actions_center">
          <button className="Action__button Action__button_all Action__button_blue">
            Добавить
          </button>
        </div>

        {/*<div className="Form__actions Form__actions_center">*/}
        {/*  <div className="Action__link" onClick={() => props.handleClose()}>*/}
        {/*    Отмена*/}
        {/*  </div>*/}
        {/*</div>*/}
      </form>
    </Modal>
  );
}

export default ModalAddHandbookEntry;
